const getContentType = (fieldGroupName) => {
  return fieldGroupName.split('_').slice(-1).toString().toLowerCase()
}

export default getContentType
